export type operationType = "C" | "R" | "U" | "D";
export type roleType =
  | "DO-DILAdmin"
  | "DO-OrgAdmin"
  | "DO-EnvironmentManager"
  | "DO-Installer"
  | "DO-BasicUser";

export type UserRoleOption = {
  value: roleType;
  label: string;
};

export const userRoleOptions: UserRoleOption[] = [
  { value: "DO-DILAdmin", label: "DIL Admin" },
  { value: "DO-OrgAdmin", label: "Admin" },
  { value: "DO-EnvironmentManager", label: "Environment Manager" },
  { value: "DO-Installer", label: "Installer" },
  { value: "DO-BasicUser", label: "Basic User" },
];

export function creatableUserRoleOptions(
  callerGroups: unknown,
): UserRoleOption[] {
  if (!Array.isArray(callerGroups)) {
    return [];
  }
  if (callerGroups.includes("DO-DILAdmin")) {
    return userRoleOptions;
  }
  if (callerGroups.includes("DO-OrgAdmin")) {
    return userRoleOptions.filter((role) =>
      ["DO-OrgAdmin", "DO-Installer", "DO-BasicUser"].includes(role.value),
    );
  }
  return [];
}

export function canManageUserRole(
  callerGroups: unknown,
  targetRole: unknown,
): boolean {
  return creatableUserRoleOptions(callerGroups).some(
    (role) => role.value === targetRole,
  );
}

export type resourceType =
  | "desks"
  | "doors"
  | "door-sensors"
  | "floors"
  | "locations"
  | "logs"
  | "reports"
  | "sensors"
  | "users";

export type RolesWithPermissons = Record<
  roleType,
  {
    name: roleType;
    permissions: Record<resourceType, operationType[]>;
  }
>;
